import { generalService } from "@database/services";
import React, { createContext, useState, PropsWithChildren, useEffect, useCallback } from "react";

interface GeneralContextType {
    terms: string;
}

export const GeneralContext = createContext<GeneralContextType>({
    terms: ''
});

export const GeneralContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const [terms, setTerms] = useState<string>('');

    const onGetTerms = useCallback(async () => {
        try {
            const response = await generalService.getTerms();
            if (response.code === 200) {
                setTerms(response.data.data.content);
            }
        } catch (error) {
            console.error("Failed to fetch terms:", error);
        }
    }, []);

    useEffect(()=> {
        onGetTerms();
    }, []);

    return (
        <GeneralContext.Provider
            value={{ terms }}
        >
            {children}
        </GeneralContext.Provider>
    );
};
